import Keycloak from 'keycloak-js';
import { createStore } from 'zustand';

import { makeZustandContextStore } from '@/utils/zustandUtils';

export type KeycloakAuthData = {
  initialized: boolean;
  impersonating: boolean;
  keycloak: Keycloak;
};

export type KeycloakAuthState = KeycloakAuthData & {
  setImpersonating: (impersonating: boolean) => void;
  setInitialized: (initialized: boolean) => void;
};

const createKeycloakAuthStore = (initProps: KeycloakAuthData) => {
  return createStore<KeycloakAuthState>()(set => ({
    ...initProps,
    setImpersonating: (impersonating: boolean) => set({ impersonating }),
    setInitialized: (initialized: boolean) => set({ initialized }),
  }));
};

export const [, KeycloakAuthProvider, useKeycloak] = makeZustandContextStore<
  KeycloakAuthData,
  KeycloakAuthState
>('KeycloakAuth', createKeycloakAuthStore);
